module.exports = __webpack_public_path__ + "fonts/c36f080.woff2";